import { render } from "./css-chapter-2.vue?vue&type=template&id=c4036f78"
import script from "./css-chapter-2.vue?vue&type=script&lang=js"
export * from "./css-chapter-2.vue?vue&type=script&lang=js"

import "./css-chapter-2.vue?vue&type=style&index=0&id=c4036f78&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__